export default "__VITE_ASSET__787ad013__"